import { match } from 'ts-pattern';
import type { Translate } from 'next-translate';

import type { MarketSubCategory } from '../services/interfaces/market.types';

export type MarketLineUnit = 'points' | 'goals' | 'runs';

export const getMarketLineUnit = (subCategory: MarketSubCategory | undefined): MarketLineUnit =>
  match(subCategory)
    .returnType<MarketLineUnit>()
    .with('mls', 'epl', 'nhl', () => 'goals')
    .with('mlb', () => 'runs')
    .otherwise(() => 'points');

export const withMarketLineUnit = (
  lineDisplay: string,
  subCategory: MarketSubCategory | undefined,
  t: Translate
): string => `${lineDisplay} ${t(`selection.lineUnits.${getMarketLineUnit(subCategory)}`)}`;
